import { ActionTypes } from '../constants/index';

export const fetchDashboardData = (payload: any) => ({
  type: ActionTypes.DASHBOARD_DATA_REQUEST,
  payload,
});
